import { createReducer } from 'typesafe-actions';
import { UserState } from './types';
import { displayUserInfo } from './actions';

export const INITIAL_STATE: UserState = {
  name: '',
  isLoading: true,
  error: 0,
};

export type RootUserActions = ReturnType<typeof displayUserInfo>;

const userReducer = createReducer<UserState, RootUserActions>(INITIAL_STATE, {
  '@user/DISPLAY_USER_INFO': (state, action) => ({
    isLoading: false,
    error: 0,
    name: action.payload,
  }),
});

export default userReducer;
